import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService, AppInformationService, ArkUnitOfWork, UtilityService } from 'app/core/core.module';
import { CommitteeMember, Family, Nomination, NominationAssignment, Person } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { confirm, alert } from 'devextreme/ui/dialog';
import moment from 'moment';
import _ from 'lodash';
import { xor } from 'lodash';

@Component({
    selector: 'app-nomination-overview',
    templateUrl: './nomination-overview.component.html',
    styleUrls: ['./nomination-overview.component.scss'],
})
export class NominationOverviewComponent implements OnInit {
    nomination: Nomination;
    nominations: any;
    people: any[];
    roles = ['Deacon', 'Shepherding Elder', 'Executive Elder'];
    nominationGroups: any;
    assignment: any = {};
    assignments: NominationAssignment[];

    @ViewChild('nominationGrid') nominationGrid: DxDataGridComponent;
    @ViewChild('groupGrid') groupGrid: DxDataGridComponent;
    @ViewChild('assignmentGrid') assignmentGrid: DxDataGridComponent;

    selectedMonthId: number;
    givingTypes: any[];
    types: any[];
    otherAccounts: any[];

    specialAccountId: number;
    batchId: number;
    saveEnable = true;
    addProcessing = false;
    processing = false;
    bankAmounts: any[];
    bankEntry: any;
    fee = 0.0;
    cloverTotal = 0.0;
    previousBatches: any;
    previousBatch: any;
    nextMonthTotal = 0.0;
    yearValue: any;

    @ViewChild('personSelect') personSelect: any;
    @ViewChild('bankSelect') bankSelect: any;
    @ViewChild('nextGrid') nextGrid: DxDataGridComponent;
    @ViewChild('bankGrid') bankGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private appInfo: AppInformationService,
        private auth: AuthService,
        private utility: UtilityService,
        private modalService: BsModalService
    ) {}

    async ngOnInit() {
        this.nomination = this.uow.nominations.createEntity();

        await this.getData();
        await this.getGroupedData();
        await this.getAssignments();
        this.people = await this.uow.getPeopleForNominations();
    }

    async getData() {
        this.nominations = await this.uow.getNominations();
    }

    async getGroupedData() {
        this.nominationGroups = await this.uow.getNominationGroups();
        let i = 0;
        this.nominationGroups.forEach((x) => {
            x.id = i;
            i++;
        });
        // console.log(this.nominationGroups);
    }
    async getAssignments() {
        this.assignments = (await this.uow.getNominationConfirmed()) as NominationAssignment[];
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            }
        );
    }

    onSelectionChange(e) {
        if (e.rowType === 'data') {
            if (!!e.data.currentMonth) {
                e.rowElement.className = e.rowElement.className + ' currentMonth-grid ';
            }
            if (!!e.data.nextMonth) {
                e.rowElement.className = e.rowElement.className + ' nextMonth-grid ';
            }
        }
    }

    async add() {
        this.addProcessing = true;
        const previousRole = this.nomination.role;
        this.nomination.created = new Date();
        this.nomination.createdBy = this.auth.currentUser.userName;
        await this.uow.commit();

        this.nomination = this.uow.nominations.createEntity();
        this.nomination.role = previousRole;
        this.addProcessing = false;
        await this.getData();

        setTimeout(() => {
            this.personSelect.instance.focus();
        });
    }
    async deleteNomination() {
        const selectedRows = this.nominationGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;

        const rows = selectedRows.slice();
        rows.forEach((row) => {
            row.entityAspect.setDeleted();
        });
        await this.uow.commit();
        await this.getData();

        this.nomination = this.uow.nominations.createEntity();
    }

    async confirm() {
        if (!this.nomination.entityAspect.entityState.isDetached()) this.nomination.entityAspect.rejectChanges();
        const selectedRows = this.groupGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;
        const rows = selectedRows;
        this.appInfo.pleaseWaitShow();

        for (let index = 0; index < selectedRows.length; index++) {
            const row = selectedRows[index];
            const assignment = this.uow.nominationAssignments.createEntity();
            assignment.personId = row.personId;
            assignment.role = this.assignment.role;
            assignment.created = new Date();
            assignment.confirmed = new Date();
            assignment.createdBy = this.auth.currentUser.userName;
        }
        await this.uow.commit();
        await this.getData();
        await this.getAssignments();
        this.groupGrid.instance.clearSelection();
        this.assignment.role = null;
        this.appInfo.pleaseWaitHide();
    }

    async markAssignment(mode: string) {
        if (!this.nomination.entityAspect.entityState.isDetached()) this.nomination.entityAspect.rejectChanges();
        const selectedRows = this.assignmentGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;
        const rows = selectedRows;
        this.appInfo.pleaseWaitShow();

        selectedRows.forEach((row) => {
            if (mode === 'Accept') row.accepted = new Date();
            if (mode === 'Decline') row.declined = new Date();
            if (mode === 'Delete') row.deleted = new Date();
            if (mode === 'Clear') {
                row.accepted = null;
                row.declined = null;
            }
        });
        await this.uow.commit();
        await this.getAssignments();
        this.assignmentGrid.instance.clearSelection();
        this.appInfo.pleaseWaitHide();
    }

    async printNominationForm() {
        const roughDate = moment({ year: new Date().getFullYear(), month: 1, day: 12 }).toDate();
        const dueDate = await this.getRole('Select Due Date', 'date', null, roughDate);
        if (!dueDate) return;
        const result = await this.utility.printNomination(dueDate);
    }

    async getRole(prompt: string, mode: string, array?: any[], value?: any): Promise<any> {
        let modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Graafschap Church',
                dialogPrompt: prompt,
                dialogValueArray: array,
                dialogValue: value,
                mode: mode,
            },
        });
        const promise = new Promise<any>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    resolve(result.value);
                }
                modalRef.hide();
                resolve(null);
            });
        });
        return promise;
    }
}
class NominationItem {
    id: number;
    personName: string;
    personId: number;
    role: string;
    constructor() {}
}
